import React, { useMemo } from 'react';
import { Selector } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.map.JoinSelector');
export default function JoinSelector(props) {
  const {
    allowBevel,
    ...rest
  } = props;
  const values = useMemo(() => {
    const opts = [{
      name: t('miter'),
      value: 'miter'
    }, {
      name: t('round'),
      value: 'round'
    }];
    if (allowBevel) {
      opts.push({
        name: t('bevel'),
        value: 'bevel'
      });
    }
    return opts;
  }, [allowBevel]);
  return /*#__PURE__*/_jsx(Selector, {
    ...rest,
    values: values
  });
}